// project imports
import config from 'config';
import ACTION_TYPE from 'components/../redux/actions/actionTypes';

export const initialState = {
    isOpen: [], // for active default menu
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    opened: true
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case ACTION_TYPE.MENU_OPEN:
            id = action.id;
            return {
                ...state,
                isOpen: [id]
            };
        case ACTION_TYPE.SET_MENU:
            return {
                ...state,
                opened: action.opened
            };
        case ACTION_TYPE.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily
            };
        case ACTION_TYPE.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius
            };
        default:
            return state;
    }
};

export default customizationReducer;
